import Cookies from 'universal-cookie';
// cookies.set('myCat', 'Pacman', { path: '/' });

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import cyan from "@material-ui/core/colors/cyan";
import teal from "@material-ui/core/colors/teal";
import axios from "axios";
import LockOpen from '@material-ui/icons/LockOpen';
import TextField from '@material-ui/core/TextField';

import { heIL } from '@material-ui/core/locale';
import Snackbar from '@material-ui/core/Snackbar';

import { useHistory } from "react-router-dom";
import MuiAlert from '@material-ui/lab/Alert';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // textAlign: "center",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  menuButton: {
    marginLeft: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
  },
}));
const theme = createMuiTheme({
  direction: "rtl", // Both here and <body dir="rtl">
  palette: {
    primary: {
      main: teal[800],
    },
    secondary: {
      main: cyan[200],
    },
    inherit: {
      main: cyan[200],
    },
  },
},heIL);

export default function Login() {
    const API_URL = "https://gw-clubadm.euro-sport.co.il"
    // const API_URL = "http://37.139.28.173:5000";
    const classes = useStyles();
    const [user_id, setUser_id] = React.useState(false);
    const [toast, setToast] = React.useState(false);
    const handleUser_id = (event) => {
        setUser_id(event.target.value)
    }
    const handleCloseToast = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
    
      setToast(false);
    
    };
    const handleSave = () =>{
        axios
        .post(API_URL + "/login",{user_id:user_id})
        .then(function (response) {
            if (response.status === 200) {
              cookies.set("login_user",response.data.response)
              // history.push("/")
              window.location.href="/"
              // history.goBack()
            }
            else{
              setToast({'severity':'error','msg':'מספר עובד לא נמצא'})
              console.log(toast)
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    }


  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        {/* {['left', 'right', 'top', 'bottom'].map((sidebar) => ( */}
          {toast && (
            <Snackbar open={toast} autoHideDuration={6000} onClose={handleCloseToast}>
            <Alert onClose={handleCloseToast} severity={toast.severity}>
              {toast.msg}
            </Alert>
          </Snackbar>
          )}
        {/* ))} */}
                <center>
              {/* <form className={classes.root} autoComplete="off" > */}
              <div><TextField id="outlined-basic" label="מספר עובד" required={true} variant="outlined" onChange={handleUser_id}/></div>
              {user_id && (<div><Button onClick={handleSave} variant="contained" color="primary" className={classes.button} startIcon={<LockOpen />}>התחבר</Button></div>)}
          {/* </form> */}
          </center>


      </div>
    </ThemeProvider>
  );
}
